import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Table, Image, Button, Icon} from "semantic-ui-react";
import { toast } from "react-toastify";
import _ from "lodash";
import cx from "classnames";
import  styles from "./collections.module.scss";
import InfiniteScroll from "components/ui/InfiniteScroll";

import Transfer from "./Transfer";
import { fetchCollections } from "actions/collections";

const initUserFilters = {
  type: "ALL",
  sort: "first_name",
  order: "ASC",
};

export default function Collections({
  account,
  type,
  query,
  sort,
  order,
  setTotal,
  setLoading,
  
}) 

{
  const dispatch = useDispatch();
  const history = useHistory();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);

  const [modalShow,setModalShow] = useState(false)

  const [filters, setFilters] = useState({ ...initUserFilters, type: type });
  const [initialRender, setInitialRender] = useState(true);

  const user = useSelector((state) => _.get(state, "users.user"));
  const loading = useSelector((state) => _.get(state, "users.loading"));
  const [selectedCollectionId, setSelectedCollectionId] = useState();
  const [selectedTransferName, setSelectedCollectionUserName] = useState();


  const collections = useSelector((state) => _.get(state, "users.collections.items"));
  const isCollectionLoading = useSelector((state) => _.get(state, "users.collections.loading"))


  const currentPage = useSelector((state) =>
    _.get(state, "users.collections.pagination.currentPage")
  );
 
  const totalPages = useSelector((state) =>
    _.get(state, "users.collections.pagination.totalPages")
  );
  
  const totalRecordsCount = useSelector((state) =>
    _.get(state, "users.collections.pagination.totalRecordsCount")
  );

  const activatingUser = useSelector((state) =>
    _.get(state, "users.activatingUser")
  );

  const creatingUser = useSelector((state) =>
    _.get(state, "users.creatingUser")
  );
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenPopup = () => {
    setIsOpen(true);
  };

  const transfer = useSelector(
    (state) => state.collections.transfer
  );

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!initialRender && creatingUser) {
      if (!creatingUser.creating && creatingUser.success) {
        setFilters({ ...filters });
    }
    }
  }, [creatingUser]);

  useEffect(() => {
    if (!initialRender && activatingUser) {
      if (!activatingUser.activating && activatingUser.success) {
        toast.success(
          ` ${user.enabled ? "Activated" : "Deactivated "} ${user.firstName}`
        );
        setFilters({ ...filters });
      }
    }
  }, [activatingUser]);

  useEffect(() => {
    if (!activatingUser.activating && !creatingUser.creating) {
      setTotal(totalRecordsCount);
    }
  }, [totalRecordsCount]);

  useEffect(() => {
    if (query) {
      query = query.trim();
    }

    setPage(0);
    setFilters({ ...filters, query: query });
  }, [query]);

  useEffect(() => {
    setPage(0);
    setFilters({ ...filters, type: type });
  }, [type]);

  useEffect(() => {
    setFilters({ ...filters });
  }, [page]);

  useEffect(() => {
    setPage(0);
    setFilters({ ...filters, sort: sort });
  }, [sort]);

  useEffect(() => {
    setPage(0);
    setFilters({ ...filters, order: order });
  }, [order]);


  useEffect(() => {
    setLoading(isCollectionLoading);
  }, [isCollectionLoading]);

  useEffect(() => {
    if (!loading && account) {
      if (query) {
        query = query.trim();
      }

      dispatch(
        fetchCollections({
          page: page,
          limit: limit,
          filters: { ...filters, account: account.id, collection: query },
        })
      );
    }
  }, [filters]);
  


  useEffect(() => {
    

    if (!isCollectionLoading && account) {
      
      dispatch(
        fetchCollections({
          page: page,
          limit: limit,
          filters: {  account: account.id },
        })
      );
    }
  }, [account]);

  useEffect(() => {
    if (!loading && initialRender) {
      setFilters({ ...filters });
    }
  }, [account]);

  useEffect(() => {
    if (!initialRender && !_.get(transfer,"updating")){
      if (transfer.success) {
        toast.success(`Collection transfer started`);
      } else {
        toast.error(`Failed to transfer`);
      }
    }
  }, [transfer]);

  setTimeout(
    function () {
      setInitialRender(false);
    },
    [3000]
  );
 

  const handleTransferClick = (id,username) =>{
    
    setModalShow(true)
    setSelectedCollectionId(id)
    setSelectedCollectionUserName(username)
  }


  

  return (
    <>
      <InfiniteScroll
        loading={loading}
        currentPage={currentPage}
        totalPages={totalPages}
        pagination={true}
        setPage={setPage}
      >
        <Table singleLine className={cx(styles.table)}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={3} className={cx(styles.header)}>
                NAME
              </Table.HeaderCell>
              <Table.HeaderCell width={3} className={cx(styles.header)}>
                CREATED BY
              </Table.HeaderCell>
              <Table.HeaderCell width={3} className={cx(styles.header)}>
                CREATED DATE
              </Table.HeaderCell>
              <Table.HeaderCell width={3} className={cx(styles.header)}>
                STATUS
              </Table.HeaderCell>
              <Table.HeaderCell width={3} className={cx(styles.header)}>
                ACTION
              </Table.HeaderCell>
              <Table.HeaderCell
                width={3}
                className={cx(styles.header)}
              ></Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body className={cx(styles.body)}>

            {isCollectionLoading && _.size(collections) === 0 && (
              <>
                <Table.Row>
                  <Table.Cell colSpan="5" className={cx(styles.cell)}>
                    <div className={cx(styles.noData)}>
                      Loading
                      <Icon name="sync" loading className={cx(styles.icon)} />
                    </div>
                  </Table.Cell>
                </Table.Row>
              </>
            )}
            
            {_.size(collections) > 0 && (
              <>
                {collections.map((item, idx) => (
                  <>
                    <Table.Row key={idx}>
                      <Table.Cell width={4} className={cx(styles.cell)}>
                        <div>
                          <Image
                            src={
                              item.icon
                                ? item.icon.thumbnail
                                : "https://react.semantic-ui.com/images/avatar/large/steve.jpg"
                            }
                            className={cx(styles.image)}
                          />
                        </div>
                        <div
                          className={cx(styles.text, styles.pointer)}
                        >
                          {item.name}
                          </div>
                      </Table.Cell>
                      <Table.Cell width={4} className={cx(styles.cell)}>
                        <div className={cx(styles.text)}> {item.createdBy} </div>
                      </Table.Cell>
                      <Table.Cell width={3} className={cx(styles.cell)}>
                        <div className={cx(styles.text)}>
                          {`${new Date(item.createdDate).getDate()}/${new Date(item.createdDate).getMonth() +1}/${new Date(item.createdDate).getFullYear()}`}
                        </div>
                      </Table.Cell>
                      
                      <Table.Cell width={2} className={cx(styles.cell)}>
                        { <div className={cx(styles.text, styles.status)}>
                          {item.status}
                        </div> }
                      </Table.Cell> 
                      <Table.Cell className={cx(styles.cell)}>
                    <span onClick={handleOpenPopup}>
                    <Button className="transfer_button" onClick={ () => handleTransferClick(item.id,item.createdBy)} >Transfer</Button>
                    </span>
                  </Table.Cell>
                      <Table.Cell
                        width={3}
                        textAlign="center"
                        className={cx(styles.cell)}
                      >
                      
                    
        
                      </Table.Cell>
                    </Table.Row>
                  </>
                ))}
              </>
            )}
          </Table.Body>
        </Table> 
        { modalShow &&
        <Transfer
        show={modalShow}
        onHide={setModalShow}
        account = {account}
        setLoading={setLoading}
        selectedCollectionId={selectedCollectionId}
        selectedTransferName={selectedTransferName}
      ></Transfer>}
      </InfiniteScroll>
    </>
  );
}
